<template>
  <div id="vertical_message_box" class="vertical_message_box">
    <van-pull-refresh v-model="isLoading" @refresh="loadMore">
      <div id="ChatRoomContent">
        <ul class="chatList" v-for="(item, index) in chatRecord" :key="index">
          <li v-if="item.module == 'text_comment'">
            <div class="chat_box">
              <div class="img fl">
                <img :src="item.header" />
              </div>
              <!-- 消息 -->
              <div class="chat_info" v-if="item.module == 'text_comment'">
                <span class="name">{{ item.nick }}:</span>
                <span class="zhuTeacher" v-if="item.showzhu == 1">老师</span>
                <span class="chat_text" v-dompurify-html="item.content"></span>
                <img style="max-width:50%;display: block;" :src="item.pic_url" v-if="item.pic_url" @load="imgOnload"
                  @click="preview(item.pic_url)" />
              </div>
              <!-- 通知 -->
              <div class="chat_info" v-if="item.module == 'notice'" >
                <span class="name">{{ item.nick }}:</span>
                <span class="chat_text" v-dompurify-html="item.content"></span>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </van-pull-refresh>
  </div>
</template>

<script>
import Vue from "vue";
import tool from "../../../kits/Tools";
import { PullRefresh } from "vant";
Vue.use(PullRefresh);
export default {
  props: ["ds_id", 'noticeObj'],
  data() {
    return {
      chatRecord: [],
      disabled: false,
      fristMsgId: "",
      isLoading: false,
      reviewWrap: [],
      isFristMsg: true
    };
  },
  watch: {
    ds_id: {
      handler(newVal, oldVal) {
        if (newVal) {
          this.loadMore()
        }
      },
      immediate: false
    },
    noticeObj(newVal, oldVal) {
      if (newVal.open) {
        let index_tmp = this.reviewWrap.findIndex(item => item.module == "notice")
        console.error("================", newVal)
        if (index_tmp != -1) {
          this.reviewWrap.splice(index_tmp, 1);
        }
        this.reviewWrap.unshift({
          module: "notice",
          content: newVal.content,
          nick: "公告",
          header: "https://shanhu-live-1317978474.cos.ap-guangzhou.myqcloud.com/web/wx-user/img/ico_gonggao%402x.png",
        });
        this.chatRecord = this.reviewWrap.concat().reverse();
      } else {
        let index_tmp = this.reviewWrap.findIndex(item => item.module == "notice")
        if (index_tmp != -1) {
          this.reviewWrap.splice(index_tmp, 1);
        }
        this.chatRecord = this.reviewWrap.concat().reverse();
      }
    }
  },
  methods: {
    loadMore() {
      console.error("加载更多");
      var that = this;
      var url = tool.baseUrl2() + "/comment/index/listsForStudent";
      var option = "ds_id=" + this.ds_id + "&_id=" + this.fristMsgId;
      this.axios
        .post(url, option)
        .then(function (res) {
          var data = res.data;
          if (data.code == "200") {
            that.reviewWrap = that.reviewWrap.concat(data.data);
            that.chatRecord = that.reviewWrap.concat().reverse();
            if (data.data.length > 0) {
              that.fristMsgId = that.reviewWrap[that.reviewWrap.length - 1]._id;
              that.isLoading = false;
            }
          } else {
            console.log(data.message);
          }
          that.isLoading = false;
          if (that.isFristMsg) {
            that.isFristMsg = false
            that.msgScrollBottom();
          }

        })
        .catch(function (res) {
          that.isLoading = false;
          console.log(res);
        });
    },
    imgOnload() {
      this.msgScrollBottom();
    },
    preview(url) {
      wx.previewImage({
        current: url, // 当前显示图片的http链接
        urls: [url], // 需要预览的图片http链接列表
      });
    },
    deleteComment(json) {
      console.log(this.reviewWrap);
      for (let i = 0; i < this.reviewWrap.length; i++) {
        var item = this.reviewWrap[i];
        if (item._id == json._id) {
          this.reviewWrap.splice(i, 1);
          break;
        }
      }
    },
    textComment(json) {
      //先审后发处理
      let hasKey = this.reviewWrap.find((item1) => {
        return item1.key == json.key && item1.key;
      });
      if (hasKey) {
        return;
      }
      //未读消息处理
      // if (this.isOnscroll) {
      // this.isShowUnReadMsg = true;
      // this.unReadMsgNum = this.unReadMsgNum + 1;
      // } else {
      // this.isShowUnReadMsg = false;
      // this.unReadMsgNum = 0;
      // }
      if (json.content && json.content != "null") {
        json.content = json.content
          .replace(/&lt;/g, "<")
          .replace(/&gt;/g, ">");
      }

      this.reviewWrap.unshift(json);

      //评论超过1千删除200
      if (this.reviewWrap.length > 400) {
        this.reviewWrap = this.reviewWrap.slice(0, 250);
      }
      this.chatRecord = this.reviewWrap.concat().reverse();
      //一秒内收到多条消息时，只刷新一次
      this.msgScrollBottom();
    },
    msgScrollBottom() {
      setTimeout(() => {
        document.getElementById(
          "vertical_message_box"
        ).scrollTop = document.getElementById(
          "vertical_message_box"
        ).scrollHeight;
      }, 0);
    }
  },
};
</script>

<style  scoped>
.vertical_message_box {
  position: absolute;
  bottom: 60px;
  left: 0;
  width: 100%;
  padding: 10px;
  z-index: 100;
  height: 200px;
  box-sizing: border-box;
  overflow: scroll;
  scroll-behavior: smooth;
}

.chatList {
  scroll-behavior: smooth;
  height: 100%;
}

.chatList li {
  margin-right: 10px;
  line-height: 26px;
  margin-top: 10px;
  overflow: hidden;
}

.chat_box {
  background: rgba(0, 0, 0, 0.28);
  padding: 4px;
  border-radius: 20px;
  padding-right: 15px;
  display: inline-block;
}

.chatList li .img,
.chatList li .img img {
  width: 26px;
  height: 26px;
  border-radius: 50%;
}

.chat_info {
  padding: 4px 0;
  line-height: 18px;
  color: #fff;
  padding-left: 35px;
}

.chat_info img {
  border-radius: 5px;
  margin-top: 5px;
}

.zhuTeacher{
   display: inline-block;
   text-align: center;
   color: #ffffff;
   background: red;
   font-size: 10px;
   margin-left: 2px;
   line-height: 13px;
   padding:2px 3px;
   border-radius: 3px;
}
</style>


// WEBPACK FOOTER //
// chatlist.vue?c0471724